// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"60bccf0a","488":"504e3ada","977":"b6c2e695"}[chunkId] + ".chunk.js";
};